import React from "react";
import Switch from "react-switch";
import { Accordion, Button, Card, Form } from "react-bootstrap";
import ValidationHelper from "../../../../helpers/ValidationHelper";
import { withTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import MarkDownEditor from "../../../../components/markdownEditor/MarkDownEditor";
import BaseDialog from "../../../../components/dialogs/baseDialog/BaseDialog";
import BaseSelect from "../../../../components/baseSelect/BaseSelect";

class CreateNetworkProfileDialog extends React.Component {
  constructor(props) {
    super(props);

    this.validationDefinition = {
      name: {
        defaultValue: "",
        rule: ValidationHelper.isName
      },
      cloudProfileId: {
        defaultValue: "",
        rule: ValidationHelper.isString
      },
      isPublished: {
        defaultValue: false,
        initValid: true,
        rule: ValidationHelper.isBoolean
      },
      description: {
        defaultValue: ValidationHelper.getDefaultValueExtendedDescription(),
        initValid: true,
        rule: ValidationHelper.isNonEmptyExtendedDescription
      }
    };

    this.state = {
      validation: ValidationHelper.getValidation(this.validationDefinition)
    };

    this.handleChange = this.handleChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onHide = this.onHide.bind(this);
  }

  handleChange(event) {
    this.setState({
      validation: ValidationHelper.update(event, this.state.validation)
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.show !== this.props.show) {
      this.setState({
        validation: ValidationHelper.getValidation(this.validationDefinition)
      });
    }
  }

  onHide() {
    this.props.onHide(ValidationHelper.hasChanged(this.state.validation));
  }

  onSubmit() {
    if (this.state.validation._isValid) {
      const validatedData = ValidationHelper.getData(this.state.validation);
      validatedData["proxyUrls"] = [];
      this.props.onSubmit(validatedData);
    }
  }

  render() {
    const { t } = this.props;
    return (
      <BaseDialog
        show={this.props.show}
        onHide={this.onHide}
        rightButtonCallback={this.onSubmit}
        title={t("NetworkProfiles.CreateModal.Form.ToggleBasic")}
        rightButtonText={t("NetworkProfiles.CreateModal.Form.Submit")}
        leftButtonText={t("DialogCancel")}
        rightButtonVariant="green"
        leftButtonVariant="black"
        leftButtonCallback={this.onHide}
        dialogApiError={this.props.dialogApiError}
        rightButtonDisabled={!this.state.validation._isValid}
        body={(<Form onSubmit={this.onSubmit}>
          <Accordion defaultActiveKey="0">
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="0"
                >
                  <span>
                    {t("NetworkProfiles.CreateModal.Form.ToggleBasic")}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="0">
                <Card.Body>
                  <Form.Group controlId="formName">
                    <Form.Label>
                      {t("NetworkProfiles.CreateModal.Form.Name")}
                    </Form.Label>
                    <Form.Control
                      type="text"
                      name="name"
                      placeholder={t(
                        "NetworkProfiles.CreateModal.Form.NamePlaceholder"
                      )}
                      value={this.state.validation.name.value}
                      isInvalid={!this.state.validation.name.isValid}
                      onChange={this.handleChange}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "NetworkProfiles.CreateModal.Form.ValidationError.Name"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSwitchIsPublished">
                    <Switch
                      className="isPublishedSwitch"
                      onColor="#54BF8D"
                      checked={this.state.validation.isPublished.value}
                      onChange={state => {
                        this.handleChange({
                          target: {
                            name: "isPublished",
                            value: state
                          }
                        });
                      }}
                      height={18}
                      width={40}
                    />
                    <Form.Label>
                      {t("NetworkProfiles.CreateModal.Form.IsPublished")}
                    </Form.Label>
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.isPublished.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "NetworkProfiles.CreateModal.Form.ValidationError.IsPublished"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                  <Form.Group controlId="formSelectSecurity">
                    <Form.Label>
                      {t("NetworkProfiles.CreateModal.Form.CloudProfile")}
                    </Form.Label>
                    <BaseSelect
                      placeholder={t(
                        "NetworkProfiles.CreateModal.Form.CloudProfilePlaceholder"
                      )}
                      options={this.props.cloudProfiles}
                      getOptionLabel={o => o.name}
                      getOptionValue={o => o.id}
                      onChange={s =>
                        this.handleChange({
                          target: {
                            name: "cloudProfileId",
                            value: s.id
                          }
                        })
                      }
                      value={this.props.cloudProfiles.find(
                        s =>
                          s.id === this.state.validation.cloudProfileId.value
                      )}
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={
                        !this.state.validation.cloudProfileId.isValid
                      }
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "NetworkProfiles.CreateModal.Form.ValidationError.CloudProfile"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
            <Card>
              <Card.Header className="pt-0 pb-0 pl-2 pr-2 custom-card-header">
                <Accordion.Toggle
                  as={Button}
                  variant="link"
                  className="acc-link"
                  eventKey="3"
                >
                  <FontAwesomeIcon
                    icon={faExclamationCircle}
                    className={
                      this.state.validation.description.isValid
                        ? "display-none"
                        : "mr-2 color-red"
                    }
                  />
                  <span>
                    {t("NetworkProfiles.CreateModal.Form.Description")}
                  </span>
                </Accordion.Toggle>
              </Card.Header>
              <Accordion.Collapse eventKey="3">
                <Card.Body>
                  <Form.Group>
                    <MarkDownEditor
                      defaultValue={ValidationHelper.getDefaultValueExtendedDescription()}
                      onChange={value =>
                        this.handleChange({
                          target: {
                            name: "description",
                            value: value
                          }
                        })
                      }
                    />
                    <Form.Control
                      type="hidden"
                      isInvalid={!this.state.validation.description.isValid}
                    />
                    <Form.Control.Feedback type="invalid">
                      {t(
                        "NetworkProfiles.CreateModal.Form.ValidationError.Description"
                      )}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Card.Body>
              </Accordion.Collapse>
            </Card>
          </Accordion>
        </Form>)}
      />
    );
  }
}

export default withTranslation()(CreateNetworkProfileDialog);
